<template>
  <div>
    <mainindex>
      <!--<div class="log" v-if="islogmode && gen._UID">-->
      <div class="log" v-if="islogmode">
        <d-close @close="islogmode=!islogmode" />
        <mainlog></mainlog>
      </div>
      <div class="content" v-if="!islogmode">
        <!--BODY-->
        <div class="body no-menu">
          <router-view v-if="$route.name !== null"></router-view>
          <div v-else>
            <template v-if="mode==='configurator'">
              <configure @nav="go($event)" lockvisual="60;45;45;false;0;360;0;90;1000;5000;false"></configure>
            </template>
          </div>
        </div>
        <!--BODY-->
      </div>
    </mainindex>
    <d-msg v-if="askend" sizex="3fr" title="CloseSession" text="close current session" yesno @close='disconnect($event)'  />
    <!--<div class="nav fixed-bottom border">
      <button @click="islogmode = !islogmode" v-html="_trans('LOGS')"></button>
    </div>-->
  </div>
</template>

<script>
import { App } from '@3cad/nextcore';
import { bus } from "@store/dau";
import "../../../scss/cattelan.scss";
import index from "@configurator/index";
import {CsearchAPI} from '@3cad/nextcore';
import {InsertItem2D} from "@3cad/nextcore";
import { ResolveForcedVars } from '@3cad/nextcore';
import { PopVariant } from '@3cad/nextcore';
import { V_ModalPopVar, V_ModalDClass } from '@vuectrls/controllers.js';
import NextModals from '@dialogs/index';
import embedded from '@configurator/embedded';

let insertItem = new InsertItem2D(App.getLoaderManager());

export default {
    mixins: [index, embedded],
    components: {
        configure: () => import("@custom/pages/configureFrame.vue")
    },
    watch: {
        $route: function (value, oldVal) {
            if (value.name === null && oldVal.name === 'rsa') {
                bus.$emit('startLoading');
            }
        }
    },
    methods: {
        requestFromParent(act, data) {
            if (!act) {
                console.warn("Missing action");
            }

            /*let data = null;
            if (e.data.data !== undefined) {
                data = e.data.data;
            } else {
                data = e.data;
            }*/
            let action = act;

            switch (action) {
                case "configure":
                    this.configureItem(data);
                    /*//Check catalog
                    if (!data.catalog) {
                        this.iframeCom.sendMsg({
                            status: 1,
                            msg: "missing catalog",
                            action: "configure"
                        });
                        return;
                    }
                    // Check model
                    if (!data.cmodel && !data.model) {
                        this.iframeCom.sendMsg({
                            status: 1,
                            msg: "missing model",
                            action: "configure"
                        });
                        return;
                    }
                    // Check item
                    if (!data.item) {
                        this.iframeCom.sendMsg({
                            status: 1,
                            msg: "missing item",
                            action: "configure"
                        });
                        return;
                    }

                    let params = {
                        cod: (data.cmodel || data.model)+ data.item,
                        neutro: data.item,
                        load: data.variant || ""
                    };

                    insertItem.insert({ item: params, side: null, skipBasket: false }, this.prj, App.getICad(), forcedResolver).then( () => {
                        // let row = this.prj.getCurrentRow();
                        // console.log(JSON.parse(JSON.stringify(row.rule)));
                        if (!this.prj.isopen) {
                            this.prj.isopen = true;
                        }
                        this.iframeCom.sendMsg({
                            status: 0,
                            msg: "item added correctly",
                            action: "configure"
                        });
                        this.go("configurator");
                    }).catch( err => {
                        this.iframeCom.sendMsg({
                            status: 1,
                            msg: err,
                            action: "configure"
                        });
                    });*/
                    break;
                case "setlang":
                    this.setAppLang(data);
                    break;
                default:
                    console.log(act, data);
                    break;
            }
        },
        setAppLang(data) {
            App.setLang(data.lang).then( () => {
                this.iframeCom.sendMsg({
                    status: 0,
                    msg: "success",
                    action: 'setlang'
                });
            }).catch( err => {
                this.iframeCom.sendMsg({
                    status: 1,
                    msg: "Fail to load language",
                    action: 'setlang'
                });
            });
        },
        configureItem(data) {
            if (!data.catalog) {
                this.iframeCom.sendMsg({
                    status: 1,
                    msg: "missing catalog",
                    action: "configure"
                });
                return;
            }
            // Check model
            if (!data.cmodel && !data.model) {
                this.iframeCom.sendMsg({
                    status: 1,
                    msg: "missing model",
                    action: "configure"
                });
                return;
            }
            // Check item
            if (!data.item) {
                this.iframeCom.sendMsg({
                    status: 1,
                    msg: "missing item",
                    action: "configure"
                });
                return;
            }
            // Build history
            CsearchAPI.getModels(data.catalog, data.model, null, json => {

                let model = {
                    des: json[0].des,
                    cmodel: json[0].cod,
                    cod: json[0].basemodel,
                    header: ''
                };
                this.prj.pushHistory(data.catalog, model);

                let params = {
                    cod: (data.cmodel || data.model)+ data.item,
                    neutro: data.item,
                    load: data.variant || ""
                };

                let modalVariant = new V_ModalPopVar(NextModals.popVariant);
                let modalDclass = new V_ModalDClass(NextModals.popDclass, {
                    size: 'xl',
                    dialogClass: 'modal-full'
                }, App.getConfig().dclass);
                let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
                let forcedResolver = new ResolveForcedVars(popVariant);

                insertItem.insert({ item: params, side: null, skipBasket: false }, this.prj, App.getICad(), forcedResolver).then( () => {
                    if (!this.prj.isopen) {
                        this.prj.isopen = true;
                    }

                    this.iframeCom.sendMsg({
                        status: 0,
                        msg: "success",
                        action: 'configure'
                    });

                    this.go("configurator");
                }).catch( err => {
                    this.iframeCom.sendMsg({
                        status: 1,
                        msg: err,
                        action: "configure"
                    });
                });

            }, err => {
                throw err;
            })
        }
  }
};
</script>

<style scoped lang="scss">
  .no-menu {
    padding-top: 0;
  }
  .mid-menu {
    padding-top: 63px;
    //padding-top: 2.512rem;
    @include media-breakpoint-down(md) {}
  }
  .full-menu {
    padding-top: 63px;
    @include media-breakpoint-down(md) {
      //padding-top: 5.15rem;
    }
  }

.username {
  position: absolute;
  bottom: 5px;
  right: 20px;
}
.catalog {
  position: absolute;
  width:120px;
  height: 38px;
  right: 200px;
  background-color: $color;
  border: 0;
  color: $white;
}
.catalogoption {
  font-size: 0.8em;
  font-weight: normal;
}
.body {

}
.close {
  z-index: 10;
  padding-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/custom/cattelan/startFrame.vue